import {
  getTeamLabelByNumber,
  getDefaultStatisticItem
} from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null

export default {
  statisticScheme: {
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true,  editable: false }),
    'CORNER': getDefaultStatisticItem('statistic.hockey-field.corners'),
    'RED_CARD': getDefaultStatisticItem('statistic.redCard'),
    'GREEN_CARD_2_MIN': getDefaultStatisticItem('statistic.greenCard'),
    'YELLOW_CARD_5_MIN': getDefaultStatisticItem('statistic.yellowCard5min'),
    'YELLOW_CARD_10_MIN': getDefaultStatisticItem('statistic.yellowCard10min')
  },
  statisticEvents: {
    'CORNER': ['PENALTY_CORNER'],
    'RED_CARD': 'RED_CARD',
    'GREEN_CARD_2_MIN': 'GREEN_CARD_2_MIN',
    'YELLOW_CARD_5_MIN': 'YELLOW_CARD_5_MIN',
    'YELLOW_CARD_10_MIN': 'YELLOW_CARD_10_MIN'
  },
  statisticOrder: [
    'possession',
    'CORNER',
    'GREEN_CARD_2_MIN',
    'YELLOW_CARD_5_MIN',
    'YELLOW_CARD_10_MIN',
    'RED_CARD'
  ],
  statisticFunction (event) {
    const {
      isTimerStoped,
      getActiveSide,
      getMatchPeriods,
      getCurrentPeriod
    } = this

    if (!getCurrentPeriod) return

    const { EventCode, Playtime, GamePeriod } = event

    if (!getMatchPeriods[getCurrentPeriod]) {
      return
    }

    const { overriddenType } = getMatchPeriods[getCurrentPeriod]

    if (!getActiveSide && !previousActiveSide) return

    if (['START_GAME_CLOCK', 'START_PERIOD'].includes(EventCode) || overriddenType === 'shootout') {
      previousPlayTime = Playtime

      return
    }

    if (EventCode === 'STOP_GAME_CLOCK') {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'possession',
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    if (isTimerStoped) {
      previousPlayTime = Playtime

      return
    }

    if (previousActiveSide !== getActiveSide) {
      if (previousActiveSide) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'possession',
          period: GamePeriod || getCurrentPeriod,
          team: previousActiveSide,
          type: 'increment',
          value: Playtime - previousPlayTime
        })
      }

      previousActiveSide = getActiveSide
      previousPlayTime = Playtime

      return
    }

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'possession',
      period: GamePeriod || getCurrentPeriod,
      team: getActiveSide,
      type: 'increment',
      value: Playtime - previousPlayTime
    })

    previousPlayTime = Playtime
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

function getCommonPossessionStatistic (event) {
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]

  if (!getActiveSide && !previousActiveSide) return

  if (['START_GAME_CLOCK', 'START_PERIOD'].includes(EventCode) || overriddenType === 'shootout') {
    previousPlayTime = Playtime

    return
  }

  if (EventCode === 'STOP_GAME_CLOCK') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'possession',
      period: GamePeriod || getCurrentPeriod,
      team: previousActiveSide,
      type: 'increment',
      value: Playtime - previousPlayTime
    })
  }

  if (isTimerStoped) {
    previousPlayTime = Playtime

    return
  }

  if (previousActiveSide !== getActiveSide) {
    if (previousActiveSide) {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'possession',
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    previousActiveSide = getActiveSide
    previousPlayTime = Playtime

    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period: GamePeriod || getCurrentPeriod,
    team: getActiveSide,
    type: 'increment',
    value: Playtime - previousPlayTime
  })

  previousPlayTime = Playtime
}
